<template>
  <el-container id="application">
    <el-progress
      v-if="task"
      :percentage="parseInt(task.progress || '0')"
      :show-text="false"
      :stroke-width="3"
    />

    <el-aside width="49px">
      <Menu
        :bundle-id="application.bundleId"
        :backup="(application.config || {}).backup"
        :state="application.state"
        :tasks="pendingTasks"
        :active.sync="menu"
      />
    </el-aside>

    <el-main>
      <component
        v-if="application.id"
        v-bind:is="component"
        :domains="domains"
        :application="application"
        :instance="instance"
        :active-task="task"
        :tasks="pendingTasks"
        :menu.sync="menu"
        @save="save"
      />
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import Menu from '../Application/Menu'
import General from '../Application/General'
import Domain from '../Application/Domain'
import Settings from '../Application/Settings'
import Builds from '../Application/Builds'
import Sftp from '../Application/Sftp'
import Logs from '../Application/Logs'
import Redirection from '../Application/Redirection'
import Backups from '../Application/Backups'
import Destroy from '../Application/Destroy'

export default {
  props: {
    instance: {
      type: Object,
      default: () => ({})
    },
    application: {
      type: Object,
      default: () => ({})
    },
    domains: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Menu,
    General,
    Domain,
    Settings,
    Builds,
    Sftp,
    Logs,
    Redirection,
    Backups,
    Destroy
  },
  data () {
    return {
      menu: this.$route.params.menu || 'general'
    }
  },
  created () {
    this.stoppedState()
  },
  beforeMount () {
    if (this.application.state === 'creating' && this.task) {
      this.$router.push('/instances/' + this.instance.id)
    }
  },
  computed: {
    component () {
      return this.menu.charAt(0).toUpperCase() + this.menu.slice(1)
    },
    task () {
      return this.pendingTasks.find((t) => t.image === 'ansible' && t.running === '1')
    },
    pendingTasks () {
      return this.tasks.filter((t) => t.applicationId === this.application.id)
    },
    ...mapState(['tasks'])
  },
  methods: {
    save (args) {
      const payload = { ...this.application }
      if (args.config) {
        payload.config = args.config
      }
      if (args.version) {
        payload.version = args.version
      }
      if (args.package) {
        payload.package = args.package
      }

      return this.$store.dispatch('configApplication', payload)
    },
    stoppedState () {
      const state = this.application.state
      if ((state === 'stopped' || state === 'creating') && this.menu !== 'destroy') {
        this.$router.push('/instances/' + this.instance.id + '/' + this.application.id + '/destroy')
      }
    }
  },
  watch: {
    menu (value) {
      if (this.$route.params.menu !== value) {
        this.$router.push('/instances/' + this.instance.id + '/' + this.application.id + '/' + value)
      }
      this.$nextTick(this.stoppedState)
    },
    'application.state' (value) {
      if (value === 'destroying' || value === 'destroyed') {
        this.$router.push('/instances/' + this.instance.id)
      }
      if (value === 'running') {
        this.$router.push('/instances/' + this.instance.id + '/' + this.application.id)
      }
    },
    '$route.params': {
      handler (params) {
        if (params.menu) {
          this.menu = params.menu
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  @import "../../theme";

  #application {
    .el-menu-item, .el-menu-item > div {
      padding: 0 12px !important;

      &.el-badge {
        padding: 0 !important;

        .el-badge__content {
          top: 15px;
        }
      }
    }
    .el-card__body, .el-card__header {
      padding: 12px;
    }

    > .el-main {
      > div > .title-padding,
      > div {
        position: relative;

        > .action {
          position: absolute;
          right: 0;
          top: -16px;
          z-index: 99;
        }

        > .el-divider {
          margin: 15px 0 35px;

          .el-divider__text {
            background-color: #fff;

            h2, h3 {
              font-weight: 400;
            }
          }
        }

        &.title-padding {
          padding-left: 24px;
          padding-right: 24px;

          > .action {
            right: 24px;
          }
        }
      }
    }

    .pagination {
      position: sticky;
      z-index: 5;
      width: 100%;
      margin-bottom: -20px;
      border-top: 1px solid $--border-color-base;
      background-image: linear-gradient(to bottom, $--background-color-base, $--background-color-gradient);
    }
  }
</style>

<style lang="scss" scoped>
  #application {
    position: relative;
    height: 100% !important;

    .el-aside {
      height: 100%;
    }

    .el-main {
      padding: 20px 24px 0;

      > div {
        padding-bottom: 20px;

        &.stretch {
          margin-left: -24px;
          margin-right: -24px;
        }
      }
    }

    .el-progress {
      position: absolute;
      z-index: 2001;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
</style>
